module.exports = __webpack_public_path__ + "img/ta.cd7f394f.svg";